import EmbedPage from '@educator/Container/EmbedPage/EmbedPage';
import { fetchPost } from '@actions/moderator';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const Embed = () => <EmbedPage />;

Embed.pageInfo = {
  isMWebSupported: true,
  layoutOptions: {
    isCheckoutUrl: true,
    hideFooter: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

Embed.getInitialProps = setupInitialProps(async ({ store, query }) => {
  const { lessonUID } = query;
  await store.dispatch(fetchPost(lessonUID));
}, Embed.pageInfo);

export default Embed;
Embed.Layout = Layout;
Embed.Wrapper = PageReduxProvider;
